import React from 'react'
import { Avatar, Box, Button, Paper, Rating, Stack, Typography } from '@mui/material'

const GOOGLE_REVIEWS_URL = 'https://www.google.com.pk/search?kgmid=%2Fg%2F11z7g_zycf&q=Nexocart%20Perfumes'

const googleReviews = [
  {
    authorName: 'Muhammad Rizwan',
    meta: '1 review',
    time: 'a day ago',
    text: 'NEXOCART PERFUMES DELIVERS PREMIUM, LONG-LASTING FRAGRANCES WITH FAST SHIPPING AND LUXE PACKAGING THAT PUNCH WAY ABOVE THEIR PRICE.',
  },
  {
    authorName: 'abdullah aftab',
    meta: '2 reviews',
    time: '2 days ago',
    text: 'Had the honor of testing their Flora fragrance and I am happy to say it is as delightful as it is long lasting would recommend',
  },
  {
    authorName: 'Muhammad Mayo',
    meta: '1 review - 6 photos',
    time: '3 days ago',
    text: 'ALHAMDULILLAH I have received this perfume and I am quite satisfied with it. The fragrance is fresh, pleasant, and long-lasting. Delivery was on time and the packaging was secure and well-presented.',
  },
  {
    authorName: 'aina zafar',
    meta: '1 review',
    time: '5 days ago',
    text: 'Nexocart. Highly recommend.',
  },
  {
    authorName: 'Ali Shar',
    meta: '2 reviews',
    time: 'a week ago',
    text: 'Nice perfume',
  },
  {
    authorName: 'Ch haseeb Cheema',
    meta: '1 review - 4 photos',
    time: '2 weeks ago',
    text: 'cool fragrance',
  },
  {
    authorName: 'Saffa Abdullah',
    meta: '1 review',
    time: '2 weeks ago',
    text: 'Very nice fragnce and long lasting',
  },
  {
    authorName: 'Rabeebullah ghaznavi',
    meta: '2 reviews',
    time: '2 weeks ago',
    text: 'Sweet and excellet perfume',
  },
  {
    authorName: 'Ali Shan',
    meta: '1 review',
    time: '2 weeks ago',
    text: 'Amazing fragrance',
  },
  {
    authorName: 'Ch Hasnat',
    meta: '1 review',
    time: '3 weeks ago',
    text: 'My very impression after try the beautiful fragrance is awosm. The gretest thing is the fragrance is long lasting.',
  },
  {
    authorName: 'Faizan Ali',
    meta: '1 review',
    time: '3 weeks ago',
    text: 'Me ne Nexmeer by Nexocart buy kia tha Mashallah zabardst fragrance he',
  },
  {
    authorName: 'Mala Artist',
    meta: '1 review',
    time: '3 weeks ago',
    text: 'Amazing fragrance',
  },
  {
    authorName: 'Sardar laeiq Ahmad',
    meta: '2 reviews',
    time: 'Edited 3 days ago',
    text: 'Mashallah zabardast fragrance he Allah Pak kamyab farmain Ameen',
  },
  {
    authorName: 'Adnan Bhatti',
    meta: '1 review',
    time: 'a week ago',
    text: 'Mashalah Zabardst fragrance',
  },
  {
    authorName: 'Abdullah Arif',
    meta: '2 reviews',
    time: '2 weeks ago',
    text: 'Mashallah Zabardst fragrance',
  },
  {
    authorName: 'Abrar Din',
    meta: '4 reviews - 5 photos',
    time: '2 weeks ago',
    text: 'Thank you sir for your honest review',
  },
]

export const GoogleReviews = () => {
  return (
    <Box component="section" sx={{ px: { xs: 2, md: 5 }, py: { xs: 5, md: 7 }, bgcolor: '#f6f6f6' }}>
      <Stack rowGap={3} maxWidth="1180px" mx="auto">
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'center' }} gap={2}>
          <Stack rowGap={0.5}>
            <Typography variant="h3" sx={{ fontSize: { xs: '2.15rem', md: '3.15rem' }, fontWeight: 900, color: 'primary.main', lineHeight: 1.1 }}>
              Real Google Reviews
            </Typography>
            <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
              <Rating value={5} readOnly />
              <Typography variant="body1" fontWeight={600}>5.0</Typography>
              <Typography variant="body2" color="text.secondary">Based on 16 verified Google reviews from Nexocart customers</Typography>
            </Stack>
          </Stack>

          <Button variant="contained" href={GOOGLE_REVIEWS_URL} target="_blank" rel="noreferrer">
            View on Google
          </Button>
        </Stack>

        <Stack direction={{ xs: 'column', md: 'row' }} gap={2} sx={{ overflowX: { md: 'auto' }, pb: 1 }}>
          {googleReviews.map((review) => (
              <Stack
                key={`${review.authorName}-${review.time}`}
                component={Paper}
                elevation={0}
                p={2.5}
                rowGap={1.5}
                sx={{
                  minWidth: { md: 320 },
                  flex: { md: '0 0 32%' },
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 2,
                  transition: 'transform .2s ease, box-shadow .2s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 14px 30px rgba(0,0,0,.08)',
                  },
                }}
              >
                <Stack direction="row" alignItems="center" gap={1.5}>
                  <Avatar alt={review.authorName}>{review.authorName.charAt(0)}</Avatar>
                  <Stack>
                    <Typography fontWeight={700}>{review.authorName}</Typography>
                    <Typography variant="caption" color="text.secondary">{review.meta} - {review.time}</Typography>
                  </Stack>
                </Stack>
                <Rating value={5} readOnly size="small" />
                <Typography variant="body2" color="text.secondary">{review.text}</Typography>
              </Stack>
          ))}
        </Stack>
      </Stack>
    </Box>
  )
}
